import styled from "@emotion/styled";
import { LoveHandles } from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledAccountsDetailsTidContainer = styled("div")`
  margin-top: 40px;
  margin-bottom: 45px;

  @media (min-width: 1024px) {
    margin-top: 80px;
    margin-bottom: 95px;
  }
`;

export const StyledAccountsDetailsTidHeader = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 24px;
  padding-bottom: 24px;

  @media (min-width: 1024px) {
    padding-bottom: 32px;
    padding-bottom: 40px;
  }
`;

export const StyledLoveHandles = styled(LoveHandles)`
  padding-inline: 68px;
`;

export const StyledTidContainer = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 55px;
`;
